import React from "react";
import { connect } from "react-redux";
import { Col } from "react-bootstrap";
import PropTypes from "prop-types";

import Table from "../../../layout/table";
import ConditionalButton from "../../../layout/conditional-button";
import { only as numbersOnly, currency as formatCurrency  } from "../../../utils/number";
import { phone } from "../../../utils/string";
import { withNavigation } from "../../../utils/wrapper";

import { send as pageInfo, loading } from "../../../actions/page";
import { list as getRates, move as moveRate } from "../../../actions/rates";
import CsLineIcons from "../../../cs-line-icons";

class Rates extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };
        this.props.loading(true);
    }

    componentDidMount = () => {
        setTimeout(async () => {
            await this.loadData();
        }, 30);
    }


    loadData = async () => {
        this.props.loading(true);

        const __data = await this.props.getRates();

        this.setState({
            data: __data
        });

        await this.props.pageInfo({ title: "Rates", breadcrumb: `Rates` });
        this.props.loading(false);

    }


    get headers() {        
        return [
            {
                header: "Code",
                sortable: true,
                source: "code",
                className: "text-muted text-small text-uppercase w-30",
                onFormat: this.onLinkFormat
            },
            {
                header: "Name",
                sortable: true,
                source: "name",
                className: "text-muted text-small text-uppercase w-30",
                onFormat: this.onLinkFormat
            },
            {
                header: "Type",
                sortable: true,
                source: "style",
                className: "text-muted text-small text-uppercase w-30",
                onFormat: this.onStyleLinkFormat
            },
            {
                header: "Amount",
                sortable: true,
                source: "value",
                className: "text-muted text-small text-uppercase w-40",
                onFormat: this.onValueFormat
            },
            {
                header: "",
                sortable: false,
                source: "uuid",
                onRender: this.onSortRender
            }
        ]
    }

    onMoveClick = async ({ uuid, index, move }) => {
        await this.props.moveRate({
            uuid,
            ordinal: move
        });
        await this.loadData();
    }

    onSortRender = (e, row) => {
        return <>
            <div style={{ cursor: 'pointer' }}  onClick={(evt) => this.onMoveClick({
                uuid: row["uuid"],
                index: row["index"],
                move: -1
            }) } >
                <CsLineIcons icon="arrow-double-top" height="16px" />
            </div>
            <div style={{ cursor: 'pointer' }}  onClick={(evt) => this.onMoveClick({
                uuid: row["uuid"],
                index: row["index"],
                move: 1
            }) } >
                <CsLineIcons icon="arrow-double-bottom" height="16px" />
            </div>
        </>;
    }

    onValueFormat = (e, row) => {
        return row['style'] === "C" ? e+" %" : formatCurrency(Number(e));
    }

    onStyleLinkFormat = (e, row) => {
        let label = ""; 
        switch (e) {
            case "H":
                label = "Frequency";
                break;
            case "C":
                label = "Contingency";
                break;
            case "F":
                label = "Flat";
                break;        
            default:
                break;
        }
        return this.onLinkFormat(label, row)
    }

    onLinkFormat = (e, row) => {
        return `<a href="/dashboard/settings/rates/${row['uuid']}">${e}</a>`
    }

    onPhoneLinkFormat = (e, row) => {
        if (!e) return "";
        let __phone = numbersOnly(e);
        if (__phone == 1) return "";
        return `<a href="tel:+${__phone}">${phone(__phone)}</a>`
    }

    onColumnClick = (e) => {

    }

    onNewClick = (e) => {
        this.props.navigate("add");
    }

    render() {
        return (
            <>
                <Col md="8" className="float-right text-end">
                    <ConditionalButton enabledVariant="outline-primary" tooltip="Create new rate" display enabled={true} onEnabledClick={this.onNewClick} icon="flash">New</ConditionalButton>
                </Col>
                <Col xs="12">
                    <Table
                        headers={this.headers}
                        page={this.state.data}
                        size={this.state.size}
                        index={this.state.page}
                        pages={this.state.pages}
                        onColumnClick={this.onColumnClick}
                        onPageChange={this.onPageChange}
                        onSearch={this.onSearch}
                        onSize={this.onSize}
                        searchable={false}
                        sizable={false}
                    />
                </Col>
            </>
        )
    }
}

Rates.propTypes = {
    auth: PropTypes.object.isRequired
};

const mapStateToProps = (state) => {
    return ({
        auth: state.auth
    });
};

export default withNavigation(connect(mapStateToProps, { getRates, moveRate, loading, pageInfo })(Rates));
